import { render, staticRenderFns } from "./CodifierForm.vue?vue&type=template&id=dc2c0262&scoped=true&"
import script from "./CodifierForm.vue?vue&type=script&lang=js&"
export * from "./CodifierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2c0262",
  null
  
)

export default component.exports